import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import axios from 'axios';

const API = process.env.REACT_APP_API_URL;

export default function CallbackSaldo() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [estado, setEstado] = useState('procesando'); // procesando | exito | error

  useEffect(() => {
    const call = searchParams.get('call');
    if (call) {
      console.log('Llamando callback saldo con call:', call);
      axios.post(`${API}/prod/callback`, { call })
        .then((res) => {
          console.log('Callback response:', res.data);
          setEstado('exito');
        })
        .catch((err) => {
          console.error('Callback error:', err);
          fetch(`https://l0sqt7a9v0.execute-api.us-east-1.amazonaws.com/prod/callback`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ call }),
            mode: 'no-cors'
          }).catch(() => {});
          setEstado('exito');
        });
    } else {
      setEstado('exito');
    }
  }, [searchParams]);

  return (
    <div style={{
      minHeight: '80vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 20,
    }}>
      <div style={{
        background: '#fff',
        borderRadius: 20,
        padding: '40px 24px',
        textAlign: 'center',
        maxWidth: 400,
        width: '100%',
        boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
      }}>
        {estado === 'procesando' ? (
          <>
            <div style={{ fontSize: 48, marginBottom: 16 }}>⏳</div>
            <h2 style={{ color: '#1a3a2a', marginBottom: 8 }}>Procesando...</h2>
            <p style={{ color: '#6b8f71', fontSize: 14 }}>Confirmando tu compra de saldo</p>
          </>
        ) : (
          <>
            <div style={{ fontSize: 48, marginBottom: 16 }}>✅</div>
            <h2 style={{ color: '#1a3a2a', marginBottom: 8 }}>¡Compra Exitosa!</h2>
            <p style={{ color: '#6b8f71', fontSize: 14, marginBottom: 24 }}>
              Tu saldo se acreditará en unos momentos.
            </p>
            <button
              onClick={() => navigate('/dashboard')}
              style={{
                padding: '14px 32px',
                background: '#1a3a2a',
                color: '#fff',
                border: 'none',
                borderRadius: 12,
                fontSize: 15,
                fontWeight: 700,
                cursor: 'pointer',
              }}
            >
              Ir a mi Panel
            </button>
          </>
        )}
      </div>
    </div>
  );
}
